import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Offcanvas, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaSignOutAlt, FaKey, FaClipboardList, FaCog, FaChartBar, FaTools, FaMicroscope, FaHome } from "react-icons/fa";
import styles from "./sidebarMenu.module.css";


const SidebarMenu = ({ onLogout, onChangePassword }) => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path ? styles.active : "";

  const handleLogout = () => {
    // Borrar los elementos de sessionStorage
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("userEmail");
    sessionStorage.removeItem("userNombre");
    sessionStorage.removeItem("userActivo");
    sessionStorage.removeItem("Esttoken");

    // Redirigir al login
    navigate("/login");
  };

  const handleOperaciones = () => {
    navigate("/operaciones");
  };

  const handleHome = () => {
    navigate("/home");
  }
  const handleParametrizacion = () => {
    navigate("/parametrizacion");
  };

  const handleRegistroyctrol = () => {
    navigate("/registroycontrol");
  };



  return (
    <>
      {/* Botón hamburguesa móvil */}
      <button
        className={styles.mobileToggleButton + " d-md-none"}
        onClick={() => setShow(true)}
      >
        <FaBars size={20} />
      </button>

      {/* Sidebar desktop */}
      <div className={`${styles.sidebar} d-none d-md-flex`}>
        <h4 className={styles.sidebarTitle}>SIISC</h4>

        <button
          className={`${styles.menuButton} ${isActive("/home")}`}
          onClick={() => navigate("/home")}
        >
          <FaHome /> Home
        </button>
        <button
          className={`${styles.menuButton} ${isActive("/registroycontrol")}`}
          onClick={() => navigate("/registroycontrol")}
        >
          <FaClipboardList /> Registro y Control
        </button>
        <button
          className={`${styles.menuButton} ${isActive("/operaciones")}`}
          onClick={() => navigate("/operaciones")}
        >
          <FaTools /> Operaciones
        </button>
        <button
          className={`${styles.menuButton} ${isActive("/analisis")}`}
          onClick={() => navigate("/analisis")}
        >
          <FaMicroscope /> Análisis
        </button>
        <button className={styles.menuButton} onClick={() => navigate("/parametrizacion")}>
          <FaCog /> Parametrización
        </button>
        <button className={styles.menuButton} onClick={() => navigate("/informes")}>
          <FaChartBar /> Informes
        </button>

        <div className="mt-auto">
          <button className={styles.menuButton} onClick={onChangePassword}>
            <FaKey /> Cambiar Contraseña
          </button>
          <button className={styles.logoutButton} onClick={handleLogout}>
            <FaSignOutAlt /> Cerrar Sesión
          </button>
        </div>
      </div>

      {/* Offcanvas móvil */}
      <Offcanvas show={show} onHide={() => setShow(false)} backdrop="static" responsive="md">
        <Offcanvas.Header closeButton className={styles.offcanvasHeader}>
          <Offcanvas.Title>Menú</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className={styles.offcanvasBody}>
          <button className={styles.offcanvasButton} onClick={() => { setShow(false); navigate("/registroycontrol"); }}>
            <FaClipboardList /> Registro y Control
          </button>
          <button className={styles.offcanvasButton} onClick={() => { setShow(false); navigate("/operaciones"); }}>
            <FaTools /> Operaciones Generales
          </button>
          <button className={styles.offcanvasButton} onClick={() => { setShow(false); navigate("/parametrizacion"); }}>
            <FaCog /> Parametrización
          </button>
          <button className={styles.offcanvasButton}>
            <FaChartBar /> Informes
          </button>
          <hr />
          <button className={styles.offcanvasButton} onClick={() => { setShow(false); onChangePassword(); }}>
            <FaKey /> Cambiar Contraseña
          </button>
          <button className={styles.logoutButton} onClick={() => { setShow(false); onLogout(); }}>
            <FaSignOutAlt /> Cerrar Sesión
          </button>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SidebarMenu;
